import i18n from 'i18next';
import * as Yup from 'yup';
import { FormularioUsuario } from '../../../@types/exports';

const validarErroForm = async (data: FormularioUsuario) => {
  const schema = Yup.object().shape({
    name: Yup
      .string()
      .matches(/[a-zA-Z]\s[a-zA-Z]/, i18n.t('usuarios.validacao.nome'))
      .required(i18n.t('usuarios.validacao.nomeObrigatorio')),
    username: Yup
      .string()
      .required(i18n.t('usuarios.validacao.username')),
    email: Yup
      .string()
      .email(i18n.t('usuarios.validacao.emailInvalido'))
      .required(i18n.t('usuarios.validacao.email')),
  });

  await schema.validate(data, {
    abortEarly: false,
  });
};

export default validarErroForm;
